export default __webpack_public_path__ + "static/media/Dejan.54e09f3f.jpg";